/*jshint esversion: 9 */
import React from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import { DEFAULT_GRID_OPTIONS } from "@material-ui/x-grid";
// import { withStyles } from "@material-ui/core/styles";
import {
  doLog,
  getAppOptions,
  getFeetInches,
  getMMDDYYYY,
  hasValue,
  notNull,
  updateObject,
} from "../shared/utility";

import * as actions from "../store/actions/index";
import Button from "@material-ui/core/Button";
import Card from "../components/UI/Card/Card";
import Checkbox from "@material-ui/core/Checkbox";
import classes from "./CrimeSubmission.css";
import Grid from "@material-ui/core/Grid";
import Form from "../components/UI/Form/Form";
import SectionHeading from "../components/UI/SectionHeading/SectionHeading";

const sectionName = "Person";
// const quote = '"';
// const singleQuote = "'";
const { rowHeight, headerHeight } = DEFAULT_GRID_OPTIONS;

const mappedSelectPropFields = [
  "personInvolvement",
  "olnState",
  "homeState",
  "workState",
  "race",
  "sex",
  "ethnicity",
  "eyeColor",
  "hairColor",
];

const mappedTextPropFields = [
  "firstName",
  "middleName",
  "lastName",
  // "email",
  "homePhone",
  "cellPhone",
  "workPhone",
  "dob",
  "oln",
  "height",
  "weight",
  "ssn",
  "nameType",
  //
  "homeStreetNumber",
  "homeStreetName",
  "homeApt",
  "homeCity",
  "homeState",
  "homeZip",
  //
  "workBusinessName",
  "workStreetNumber",
  "workStreetName",
  "workApt",
  "workCity",
  "workState",
  "workZip",
  //
  "id",
  "deleted",
  "timsNameID",
  // search versions of fields:
  "firstNameSearch",
  "middleNameSearch",
  "lastNameSearch",
  "suffixSearch",
  "dobSearch",
  "raceSearch",
  "sexSearch",
];
// If fields are added to this list, also update getMappedPropValue and putMappedPropValue functions

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
// });

// const gridSpacing = 8; //0 or 8 or 16 or 24 or 32 or 40

class Person extends Form {
  state = {
    editMode: true,
    itemProcessed: false,
    timeoutSecs: 10,
    requiredFieldErrMsg: "Required fields are needed",
    sectionName: sectionName,
    runTIMSSearch: false,
    useSameAsYou: false,
    //
    mappedSelectPropFields: mappedSelectPropFields,
    mappedTextPropFields: mappedTextPropFields,
    //
    personInvolvement: {
      inputType: "select",
      labelValue: null,
      value: null,
      label: "Involvement Type",
      listName: "personInvolvementList",
      codegroup: "163",
      validation: { required: true },
    },
    nameType: {
      inputType: "checkbox",
      value: "P",
      default: "P",
      label: "This is a business/organization",
      checkedValue: "O",
      uncheckedValue: "P",
    },
    firstName: {
      inputType: "text",
      value: "",
      label: "First Name",
      validation: { required: true },
    },
    middleName: { inputType: "text", value: "", label: "Middle" },
    lastName: {
      inputType: "text",
      value: "",
      label: "Last Name",
      validation: { required: true },
    },
    // email: {
    //   inputType: "email",
    //   value: "",
    //   label: "Email",
    //   validation: { required: true },
    // },
    homePhone: { inputType: "phone", value: "", label: "Home Phone" },
    cellPhone: { inputType: "phone", value: "", label: "Cell Phone" },
    workPhone: { inputType: "phone", value: "", label: "Work Phone" },
    race: {
      inputType: "select",
      valueField: "raceValue",
      value: null,
      label: "Race",
      listName: "raceList",
      codegroup: "8",
      validation: { required: true },
    },
    sex: {
      inputType: "select",
      valueField: "sexValue",
      value: null,
      label: "Gender",
      listName: "sexList",
      codegroup: "9",
      validation: { required: true },
    },
    ethnicity: {
      inputType: "select",
      valueField: "ethnicityValue",
      value: null,
      label: "Ethnicity",
      listName: "ethnicityList",
      codegroup: "10",
      validation: { required: false },
    },
    dob: {
      inputType: "date",
      value: null,
      label: "Date of Birth",
      disableFuture: true,
      validation: { required: true },
    },
    oln: {
      inputType: "text",
      value: "",
      label: "Driver License #",
      upperOnly: true,
    },
    olnState: {
      inputType: "select",
      valueField: "olnStateValue",
      value: "MI",
      label: "License State",
      listName: "stateList",
      codegroup: "162",
    },
    height: {
      inputType: "height",
      value: "",
      label: "Height",
    },
    weight: {
      inputType: "number",
      value: "",
      label: "Weight",
    },
    eyeColor: {
      inputType: "select",
      valueField: "eyeColorValue",
      value: null,
      label: "Eye Color",
      listName: "eyeColorList",
      codegroup: "13",
    },
    hairColor: {
      inputType: "select",
      valueField: "hairColorValue",
      value: null,
      label: "Hair Color",
      listName: "hairColorList",
      codegroup: "14",
    },
    ssn: {
      inputType: "ssn",
      value: "",
      label: "SSN",
    },
    homeStreetNumber: { inputType: "text", value: "", label: "Street #" },
    homeStreetName: { inputType: "text", value: "", label: "Street Name" },
    homeApt: { inputType: "text", value: "", label: "Unit" },
    homeCity: { inputType: "text", value: "", label: "City" },
    homeState: {
      inputType: "select",
      valueField: "homeStateValue",
      value: "MI",
      label: "State",
      listName: "stateList",
      codegroup: "162",
    },
    homeZip: { inputType: "text", value: "", label: "Zip" },
    workBusinessName: {
      inputType: "text",
      value: "",
      label: "Business/Organization Name (If appropriate)",
      validation: { required: false },
    },
    workStreetNumber: { inputType: "text", value: "", label: "Street #" },
    workStreetName: { inputType: "text", value: "", label: "Street Name" },
    workApt: { inputType: "text", value: "", label: "Unit" },
    workCity: { inputType: "text", value: "", label: "City" },
    workState: {
      inputType: "select",
      valueField: "workStateValue",
      value: "MI",
      label: "State",
      listName: "stateList",
      codegroup: "162",
    },
    workZip: { inputType: "text", value: "", label: "Zip" },
    //
    id: {
      inputType: "text",
      value: "-1",
      label: "ID",
      validation: { required: false },
    },
    timsNameID: {
      inputType: "text",
      value: "-1",
      label: "TIMSNameID",
      validation: { required: false },
    },
    deleted: {
      inputType: "text",
      value: "",
      label: "Deleted",
      validation: { required: false },
    },
    //
    firstNameSearch: {
      inputType: "text",
      value: "",
      label: "First",
      upperOnly: true,
    },
    middleNameSearch: {
      inputType: "text",
      value: "",
      label: "Middle",
      upperOnly: true,
    },
    lastNameSearch: {
      inputType: "text",
      value: "",
      label: "Last",
      upperOnly: true,
    },
    suffixSearch: {
      inputType: "text",
      value: "",
      label: "Suffix",
      upperOnly: true,
    },
    dobSearch: {
      inputType: "date",
      value: null,
      label: "Date of Birth",
      disableFuture: true,
    },
    raceSearch: {
      inputType: "select",
      valueField: "raceValue",
      value: null,
      label: "Race",
      listName: "raceList",
      codegroup: "8",
    },
    sexSearch: {
      inputType: "select",
      valueField: "sexValue",
      value: null,
      label: "Gender",
      listName: "sexList",
      codegroup: "9",
    },
    //
    timsSearch: {
      inputType: "checkbox",
      value: "N",
      default: "N",
      label: "Search in TIMS: (Optional)",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
  };

  addNewPersonItem() {
    this.setState({ useSameAsYou: false });
    const newInstance = this.props.personArray.length;
    const personFields = null;
    const personItem = {
      personInstance: newInstance,
      personFields: personFields,
    };

    if (doLog())
      console.log("[Person] addNewPersonItem personItem:", personItem);
    this.props.onAddToPersonArray(this.props.personArray, personItem);
  }

  checkAndLoadConfig() {
    if (this.props.configuration !== null) {
      if (doLog())
        console.log(
          "[Person]checkAndLoadConfig ciddbConnectionName:",
          this.props.configuration.ciddbConnectionName
        );
      if (
        this.props.configuration !== null &&
        this.props.configuration.ciddbConnectionName !== null
      ) {
        if (this.props.personSelectFieldList === null) {
          this.props.onSetPersonSelectFieldList(mappedSelectPropFields);
        } else if (this.props.personTextFieldList === null) {
          this.props.onSetPersonTextFieldList(mappedTextPropFields);
        }
      }
    }
  }

  checkIfBusiness() {
    const requiredOption = { required: true };
    const notRequiredOption = { required: false };
    const thisInstance = this.props.item.personInstance;
    let updateArray = false;
    if (doLog())
      console.log("[Person] checkIfBusiness thisInstance:", thisInstance);
    if (doLog())
      console.log(
        "[Person] checkIfBusiness nameType:",
        this.state.nameType.value
      );
    if (doLog())
      console.log(
        "[Person] checkIfBusiness workBusinessName validation:",
        this.state.workBusinessName.validation.required
      );
    if (doLog())
      console.log(
        "[Person] checkIfBusiness lastName:",
        this.state.lastName.value
      );

    const newPersonArray = [];
    const length = this.props.personArray.length;
    for (let i = 0; i < length; i++) {
      let personFields = null;
      const item = this.props.personArray[i];
      if (doLog())
        console.log("[Person] checkIfBusiness item[" + i + "]:", item);
      personFields = item.personFields;
      if (personFields !== null) {
        if (thisInstance === i) {
          if (
            this.state.nameType.value === "O" &&
            this.state.workBusinessName.validation.required !== true
          ) {
            if (doLog())
              console.log(
                "[Person] checkIfBusiness change person fields to not required"
              );
            updateArray = true;
            // business
            this.setState({
              workBusinessName: updateObject(this.state.workBusinessName, {
                validation: requiredOption,
              }),
              firstName: updateObject(this.state.firstName, {
                validation: notRequiredOption,
              }),
              lastName: updateObject(this.state.lastName, {
                validation: notRequiredOption,
              }),
              race: updateObject(this.state.race, {
                validation: notRequiredOption,
              }),
              sex: updateObject(this.state.sex, {
                validation: notRequiredOption,
              }),
              ethnicity: updateObject(this.state.ethnicity, {
                validation: notRequiredOption,
              }),
              dob: updateObject(this.state.dob, {
                validation: notRequiredOption,
              }),
            });
            personFields.workBusinessName.validation = requiredOption;
            personFields.firstName.validation = notRequiredOption;
            personFields.lastName.validation = notRequiredOption;
            personFields.race.validation = notRequiredOption;
            personFields.sex.validation = notRequiredOption;
            personFields.ethnicity.validation = notRequiredOption;
            personFields.dob.validation = notRequiredOption;
          } else if (
            this.state.nameType.value !== "O" &&
            this.state.workBusinessName.validation.required === true
          ) {
            if (doLog())
              console.log(
                "[Person] checkIfBusiness change person fields to required"
              );
            updateArray = true;
            this.setState({
              workBusinessName: updateObject(this.state.workBusinessName, {
                validation: notRequiredOption,
              }),
              firstName: updateObject(this.state.firstName, {
                validation: requiredOption,
              }),
              lastName: updateObject(this.state.lastName, {
                validation: requiredOption,
              }),
              race: updateObject(this.state.race, {
                validation: requiredOption,
              }),
              sex: updateObject(this.state.sex, {
                validation: requiredOption,
              }),
              ethnicity: updateObject(this.state.ethnicity, {
                validation: requiredOption,
              }),
              dob: updateObject(this.state.dob, {
                validation: requiredOption,
              }),
            });
            personFields.workBusinessName.validation = notRequiredOption;
            personFields.firstName.validation = requiredOption;
            personFields.lastName.validation = requiredOption;
            personFields.race.validation = requiredOption;
            personFields.sex.validation = requiredOption;
            personFields.ethnicity.validation = requiredOption;
            personFields.dob.validation = requiredOption;
          }
        }
      }
      // console.log(
      //   "[Person] checkIfBusiness after changes. personFields:",
      //   personFields
      // );
      newPersonArray.push({
        personFields: personFields,
        personInstance: i,
      });
    }

    if (updateArray) {
      console.log("[Person] checkIfBusiness newPersonArray:", newPersonArray);
      this.props.onSetPersonArray(newPersonArray);
    }
  }

  componentDidMount() {
    if (doLog()) console.log("[Person] componentDidMount state:", this.state);
    if (doLog()) console.log("[Person] componentDidMount props:", this.props);
    this.checkAndLoadConfig();
    this.setFieldRequiredSettings();
    this.checkIfBusiness();
  }

  componentDidUpdate() {
    if (doLog()) console.log("[Person] componentDidUpdate state:", this.state);
    if (doLog()) console.log("[Person] componentDidUpdate props:", this.props);
    this.checkAndLoadConfig();
    this.copyFieldValuesToState();
    this.checkIfBusiness();
  }

  copyFieldValuesToState() {
    if (!this.state.itemProcessed) {
      if (doLog())
        console.log("[Person]copyFieldValuesToState item:", this.props.item);
      if (this.props.item !== null && this.props.item.personFields !== null) {
        const personFields = this.props.item.personFields;

        for (let field in this.state.mappedTextPropFields) {
          const fieldName = this.state.mappedTextPropFields[field];
          if (doLog())
            console.log(
              "[Person]copyFieldValuesToState text field:",
              fieldName
            );
          if (
            hasValue(personFields[fieldName]) &&
            hasValue(personFields[fieldName].value)
          ) {
            this.setState({
              [fieldName]: updateObject(this.state[fieldName], {
                value: personFields[fieldName].value,
              }),
            });
          }
        }

        for (let field in this.state.mappedSelectPropFields) {
          const fieldName = this.state.mappedSelectPropFields[field];
          if (doLog())
            console.log(
              "[Person]copyFieldValuesToState select field:",
              fieldName
            );
          if (
            hasValue(personFields[fieldName]) &&
            hasValue(personFields[fieldName].value)
          ) {
            this.setState({
              [fieldName]: updateObject(this.state[fieldName], {
                value: personFields[fieldName].value,
              }),
            });
          }
        }
      }
      this.setState({ itemProcessed: true });
    }
  }

  handleAddButton = () => {
    if (doLog()) console.log("[Person]handleAddButton");
    this.addNewPersonItem();
  };

  handleDeleteButton = () => {
    if (doLog()) console.log("[Person] handleDeleteButton");
    const personItem = this.props.item;

    if (doLog())
      console.log("[Person] handleDeleteButton personItem:", personItem);
    if (
      hasValue(personItem.personFields) &&
      hasValue(personItem.personFields.id) &&
      hasValue(personItem.personFields.id.value) &&
      personItem.personFields.id.value !== "-1"
    ) {
      if (doLog())
        console.log("[Person] handleDeleteButton setting deleted to Y");
      this.setState({
        deleted: updateObject(this.state.deleted, {
          value: "Y",
        }),
      });
      //update the personArray so that this change doesn't get overridden in copyFieldValuesToState()
      const newPersonArray = [];
      const length = this.props.personArray.length;
      for (let i = 0; i < length; i++) {
        let personFields = null;
        const item = this.props.personArray[i];
        if (doLog())
          console.log("[Person] handleDeleteButton item[" + i + "]:", item);
        if (item === personItem) item.personFields.deleted.value = "Y";
        personFields = item.personFields;
        console.log("[Person] handleDeleteButton personFields:", personFields);
        newPersonArray.push({
          personFields: personFields,
          personInstance: i,
        });
        this.props.onSetPersonArray(newPersonArray);
      }
    } else {
      this.props.onDeleteFromPersonArray(this.props.personArray, personItem);
    }
  };

  handleRowClick = (param, event) => {
    if (doLog()) console.log("[Person] handleRowClick param:", param);
    if (doLog()) console.log("[Person] handleRowClick event:", event);
    if (param != null && param.row != null) {
      const array = this.props.result.RESULT.NAME;
      const row = param.row;
      let item = null;
      if (hasValue(array.length)) item = array[row.id];
      else item = array;
      if (doLog()) console.log("[Person] handleRowClick item:", item);
      //TODO: show the spinner or wait cursor while displaying the extra item forms?
      //TODO: get the Name details after selecting a row?  This would get multiple addresses and phone numbers.
      //TODO: add AddressNumber to the eCOP incident table for the incident address and pass to CFS in the XML file?
      const nameType = notNull(item.NAMETYPE);
      let workBusinessName = "";
      let workStreetNumber = "";
      let workStreetName = "";
      let workApt = "";
      let workCity = "";
      let workState = "";
      let workZip = "";
      let homePhone = "";
      let cellPhone = "";
      let workPhone = "";
      if (nameType === "O") {
        workBusinessName = notNull(item.LASTNAME);
        workStreetNumber = item.ViaDataItems.ADDRESS.STREETNUMBER;
        workStreetName = item.ViaDataItems.ADDRESS.STREETNAME;
        workApt = item.ViaDataItems.ADDRESS.APARTMENT;
        workCity = item.ViaDataItems.ADDRESS.CITY;
        workState = item.ViaDataItems.ADDRESS.STATECODE;
        workZip = item.ViaDataItems.ADDRESS.POSTALCODE;
        workPhone = item.ViaDataItems.CONTACTMETHODS.METHODVALUE;
      } else {
        const contactType = notNull(
          item.ViaDataItems.CONTACTMETHODS.METHODTYPE
        );
        if (hasValue(contactType)) {
          if (contactType.toUpperCase() === "CELL")
            cellPhone = item.ViaDataItems.CONTACTMETHODS.METHODVALUE;
          else if (contactType.toUpperCase() === "WORK")
            workPhone = item.ViaDataItems.CONTACTMETHODS.METHODVALUE;
          else homePhone = item.ViaDataItems.CONTACTMETHODS.METHODVALUE;
        }
      }
      this.setState({
        nameType: updateObject(this.state.nameType, {
          value: nameType,
        }),
        lastName: updateObject(this.state.lastName, {
          value: item.LASTNAME,
        }),
        workBusinessName: updateObject(this.state.workBusinessName, {
          value: workBusinessName,
        }),
        firstName: updateObject(this.state.firstName, {
          value: item.FIRSTNAME,
        }),
        middleName: updateObject(this.state.middleName, {
          value: item.MIDDLENAME,
        }),
        suffix: updateObject(this.state.suffix, {
          value: item.SUFFIX,
        }),
        race: updateObject(this.state.race, {
          value: item.RACE,
        }),
        sex: updateObject(this.state.sex, {
          value: item.SEX,
        }),
        ethnicity: updateObject(this.state.ethnicity, {
          value: item.ETHNICITY,
        }),
        dob: updateObject(this.state.dob, {
          value: getMMDDYYYY(item.DOB),
        }),
        eyeColor: updateObject(this.state.eyeColor, {
          value: item.EYECOLOR,
        }),
        hairColor: updateObject(this.state.hairColor, {
          value: item.HAIRCOLOR,
        }),
        height: updateObject(this.state.height, {
          value: getFeetInches(item.HEIGHT_MIN),
        }),
        weight: updateObject(this.state.weight, {
          value: item.WEIGHT_MIN,
        }),
        oln: updateObject(this.state.oln, {
          value: item.OLN,
        }),
        olnState: updateObject(this.state.olnState, {
          value: item.OLN_STATE,
        }),
        ssn: updateObject(this.state.ssn, {
          value: item.SSN,
        }),
        homeStreetNumber: updateObject(this.state.homeStreetNumber, {
          value: item.ViaDataItems.ADDRESS.STREETNUMBER,
        }),
        homeStreetName: updateObject(this.state.homeStreetName, {
          value: item.ViaDataItems.ADDRESS.STREETNAME,
        }),
        homeApt: updateObject(this.state.homeApt, {
          value: item.ViaDataItems.ADDRESS.APARTMENT,
        }),
        homeCity: updateObject(this.state.homeCity, {
          value: item.ViaDataItems.ADDRESS.CITY,
        }),
        homeState: updateObject(this.state.homeState, {
          value: item.ViaDataItems.ADDRESS.STATECODE,
        }),
        homeZip: updateObject(this.state.homeZip, {
          value: item.ViaDataItems.ADDRESS.POSTALCODE,
        }),
        homePhone: updateObject(this.state.homePhone, {
          value: homePhone,
        }),
        cellPhone: updateObject(this.state.cellPhone, {
          value: cellPhone,
        }),
        workStreetNumber: updateObject(this.state.workStreetNumber, {
          value: workStreetNumber,
        }),
        workStreetName: updateObject(this.state.workStreetName, {
          value: workStreetName,
        }),
        workApt: updateObject(this.state.workApt, {
          value: workApt,
        }),
        workCity: updateObject(this.state.workCity, {
          value: workCity,
        }),
        workState: updateObject(this.state.workState, {
          value: workState,
        }),
        workZip: updateObject(this.state.workZip, {
          value: workZip,
        }),
        workPhone: updateObject(this.state.workPhone, {
          value: workPhone,
        }),
        timsNameID: updateObject(this.state.timsNameID, {
          value: item.NAMEID,
        }),
      });
    }
  };

  handleSameAsYouCheckBox = () => (event) => {
    this.setState({ useSameAsYou: event.target.checked });
    if (event.target.checked) {
      this.setState({
        firstName: updateObject(this.state.firstName, {
          value: this.props.sharedIncidentDetails.firstName,
        }),
        middleName: updateObject(this.state.middleName, {
          value: this.props.sharedIncidentDetails.middleName,
        }),
        lastName: updateObject(this.state.lastName, {
          value: this.props.sharedIncidentDetails.lastName,
        }),
        email: updateObject(this.state.email, {
          value: this.props.sharedIncidentDetails.email,
        }),
        homePhone: updateObject(this.state.homePhone, {
          value: this.props.sharedIncidentDetails.homePhone,
        }),
        cellPhone: updateObject(this.state.cellPhone, {
          value: this.props.sharedIncidentDetails.cellPhone,
        }),
        workPhone: updateObject(this.state.workPhone, {
          value: this.props.sharedIncidentDetails.workPhone,
        }),
        race: updateObject(this.state.race, {
          value: this.props.sharedIncidentDetails.race,
        }),
        sex: updateObject(this.state.sex, {
          value: this.props.sharedIncidentDetails.sex,
        }),
        ethnicity: updateObject(this.state.ethnicity, {
          value: this.props.sharedIncidentDetails.ethnicity,
        }),
        dob: updateObject(this.state.dob, {
          value: this.props.sharedIncidentDetails.dob,
        }),
        oln: updateObject(this.state.oln, {
          value: this.props.sharedIncidentDetails.oln,
        }),
        olnState: updateObject(this.state.olnState, {
          value: this.props.sharedIncidentDetails.olnState,
        }),
        ssn: updateObject(this.state.ssn, {
          value: this.props.sharedIncidentDetails.ssn,
        }),
        height: updateObject(this.state.height, {
          value: this.props.sharedIncidentDetails.height,
        }),
        weight: updateObject(this.state.weight, {
          value: this.props.sharedIncidentDetails.weight,
        }),
        eyeColor: updateObject(this.state.eyeColor, {
          value: this.props.sharedIncidentDetails.eyeColor,
        }),
        hairColor: updateObject(this.state.hairColor, {
          value: this.props.sharedIncidentDetails.hairColor,
        }),
        //
        homeStreetNumber: updateObject(this.state.homeStreetNumber, {
          value: this.props.sharedIncidentDetails.userStreetNumber,
        }),
        homeStreetName: updateObject(this.state.homeStreetName, {
          value: this.props.sharedIncidentDetails.userStreetName,
        }),
        homeApt: updateObject(this.state.homeApt, {
          value: this.props.sharedIncidentDetails.userApt,
        }),
        homeCity: updateObject(this.state.homeCity, {
          value: this.props.sharedIncidentDetails.userCity,
        }),
        homeState: updateObject(this.state.homeState, {
          value: this.props.sharedIncidentDetails.userState,
        }),
        homeZip: updateObject(this.state.homeZip, {
          value: this.props.sharedIncidentDetails.userZip,
        }),
        //
        // towCompanyName: this.props.sharedIncidentDetails.towCompanyName,
        // towStreetNumber: this.props.sharedIncidentDetails.towStreetNumber,
        // towStreetName: this.props.sharedIncidentDetails.towStreetName,
        // towApt: this.props.sharedIncidentDetails.towApt,
        // towCity: this.props.sharedIncidentDetails.towCity,
        // towState: this.props.sharedIncidentDetails.towState,
        // towZip: this.props.sharedIncidentDetails.towZip,
        // id: this.props.sharedIncidentDetails.id,
        // status: this.props.sharedIncidentDetails.status,
      });
    }
  };

  handleSearchTIMS = () => {
    if (doLog()) console.log("[Person] handleSearchTIMS");
    this.setState({ runTIMSSearch: true });
    this.props.onClearTransactionResult();
    this.props.onClearTransDesc();
    let transactionType =
      '<CIDDB><QUERY TABLE="Name" LIMIT="50">' +
      "  <FIELD_LIST>ALL</FIELD_LIST>" +
      '  <JOIN TABLE="NameAddressLink" OUTER="true" LEFT="true">' +
      "    <ON>" +
      '      <NameID SEARCH_TYPE="equal_to">' +
      "        <PARENT_FIELD>NameID</PARENT_FIELD>" +
      "      </NameID>" +
      '      <PreviousFlag SEARCH_TYPE="equal_to">' +
      "        <SEARCH_VALUE>N</SEARCH_VALUE>" +
      "      </PreviousFlag>" +
      "    </ON>" +
      "    <FIELD_LIST><PreviousFlag/></FIELD_LIST>" +
      '    <JOIN TABLE="Address" OUTER="true" LEFT="true">' +
      "      <ON>" +
      '        <AddressNumber SEARCH_TYPE="equal_to">' +
      "          <PARENT_FIELD>AddressNumber</PARENT_FIELD>" +
      "        </AddressNumber>" +
      "      </ON>" +
      "      <FIELD_LIST>ALL</FIELD_LIST>" +
      "    </JOIN>" +
      "  </JOIN>" +
      '  <JOIN TABLE="NameContactMethodsLink" LEFT="TRUE">' +
      '    <FIELD_LIST Order="2"/>' +
      "    <ON>" +
      '      <NameID SEARCH_TYPE="equal_to">' +
      "        <PARENT_FIELD>NameID</PARENT_FIELD>" +
      "      </NameID>" +
      "    </ON>" +
      '    <JOIN TABLE="ContactMethods" OUTER="true" LEFT="true">' +
      "      <ON>" +
      '        <ContactMethodsID SEARCH_TYPE="equal_to">' +
      "          <PARENT_FIELD>ContactMethodsID</PARENT_FIELD>" +
      "        </ContactMethodsID>" +
      "      </ON>" +
      "      <FIELD_LIST>ALL</FIELD_LIST>" +
      "    </JOIN>" +
      "  </JOIN>" +
      "  <WHERE>";
    if (hasValue(this.state.lastNameSearch.value))
      transactionType +=
        '    <LastName SEARCH_TYPE="LIKE">' +
        "      <SEARCH_VALUE>" +
        this.state.lastNameSearch.value +
        "%</SEARCH_VALUE>" +
        "    </LastName>";
    if (hasValue(this.state.firstNameSearch.value))
      transactionType +=
        '    <FirstName SEARCH_TYPE="LIKE">' +
        "      <SEARCH_VALUE>" +
        this.state.firstNameSearch.value +
        "%</SEARCH_VALUE>" +
        "    </FirstName>";
    if (hasValue(this.state.middleNameSearch.value))
      transactionType +=
        '    <MiddleName SEARCH_TYPE="LIKE">' +
        "      <SEARCH_VALUE>" +
        this.state.middleNameSearch.value +
        "%</SEARCH_VALUE>" +
        "    </MiddleName>";
    if (hasValue(this.state.suffixSearch.value))
      transactionType +=
        '    <Suffix SEARCH_TYPE="LIKE">' +
        "      <SEARCH_VALUE>" +
        this.state.suffixSearch.value +
        "%</SEARCH_VALUE>" +
        "    </Suffix>";
    if (
      hasValue(this.state.raceSearch.value) &&
      this.state.raceSearch.value !== "null"
    )
      transactionType +=
        '    <Race SEARCH_TYPE="equal_to">' +
        "      <SEARCH_VALUE>" +
        this.state.raceSearch.value +
        "</SEARCH_VALUE>" +
        "    </Race>";
    if (
      hasValue(this.state.sexSearch.value) &&
      this.state.sexSearch.value !== "null"
    )
      transactionType +=
        '    <Sex SEARCH_TYPE="equal_to">' +
        "      <SEARCH_VALUE>" +
        this.state.sexSearch.value +
        "</SEARCH_VALUE>" +
        "    </Sex>";
    transactionType +=
      '    <HistoricalRecordFlag SEARCH_TYPE="equal_to">' +
      "      <SEARCH_VALUE>N</SEARCH_VALUE>" +
      "    </HistoricalRecordFlag>" +
      "  </WHERE>" +
      "  <ORDER_BY>" +
      "    <LastName/>" +
      "    <FirstName/>" +
      "    <MiddleName/>" +
      "    <Suffix/>" +
      "  </ORDER_BY>" +
      "</QUERY></CIDDB>";
    const data = {};
    const request = {
      transactionType,
      data,
    };
    this.props.onRunTransaction(request, this.props.token, "NameList");
  };

  setFieldRequiredSettings() {
    for (let field in this.state.mappedTextPropFields) {
      const fieldName = this.state.mappedTextPropFields[field];
      const required = this.getFieldRequiredStatus(fieldName, sectionName);
      const requiredOption = { required: required };
      // if (doLog()) console.log("[Person]setFieldRequiredSettings text field:", fieldName);
      // if (doLog()) console.log("[Person]setFieldRequiredSettings required:", required);
      this.setState({
        [fieldName]: updateObject(this.state[fieldName], {
          validation: requiredOption,
        }),
      });
    }

    for (let field in this.state.mappedSelectPropFields) {
      const fieldName = this.state.mappedSelectPropFields[field];
      const required = this.getFieldRequiredStatus(fieldName, sectionName);
      const requiredOption = { required: required };
      // if (doLog()) console.log("[Person]setFieldRequiredSettings select field:", fieldName);
      // if (doLog()) console.log("[Person]setFieldRequiredSettings select required:", required);
      this.setState({
        [fieldName]: updateObject(this.state[fieldName], {
          validation: requiredOption,
        }),
      });
    }
  }

  render() {
    if (doLog())
      console.log(
        "[Person] render personInstance:",
        this.props.item.personInstance
      );

    let informationSection = null;
    if (this.props.item.personInstance === 0) {
      informationSection = (
        <Fragment>
          <Grid item xs={12}>
            <p className={classes.Information}>
              Next, please enter information about the person(s) or business(es)
              involved in the incident.
            </p>
          </Grid>
          <Grid item xs={12} className={classes.Label}>
            Who, besides yourself, was involved in the incident?
            <Checkbox
              checked={this.state.useSameAsYou}
              onChange={this.handleSameAsYouCheckBox()}
              color="default"
            />
            Copy from "Information About You" if needed
          </Grid>
        </Fragment>
      );
    }

    let searchResults = null;
    let listRows = [];
    if (
      hasValue(this.props.result !== null) &&
      hasValue(this.props.result.RESULT) &&
      hasValue(this.props.result.RESULT.NAME)
    ) {
      const array = this.props.result.RESULT.NAME;
      if (doLog()) console.log("[Person] render array:", array);
      if (doLog()) console.log("[Person] render array length:", array.length);
      if (array !== null) {
        if (hasValue(array.length)) {
          for (let i = 0; i < array.length; i++) {
            const fields = array[i];
            let address = "";
            if (
              hasValue(fields.ViaDataItems.ADDRESS.STREETNUMBER) &&
              fields.ViaDataItems.ADDRESS.STREETNUMBER.length > 0
            ) {
              address += fields.ViaDataItems.ADDRESS.STREETNUMBER + " ";
            }
            if (
              hasValue(fields.ViaDataItems.ADDRESS.STREETNAME) &&
              fields.ViaDataItems.ADDRESS.STREETNAME.length > 0
            ) {
              address += fields.ViaDataItems.ADDRESS.STREETNAME + " ";
            }
            if (
              hasValue(fields.ViaDataItems.ADDRESS.APARTMENT) &&
              fields.ViaDataItems.ADDRESS.APARTMENT.length > 0
            ) {
              address += fields.ViaDataItems.ADDRESS.APARTMENT + " ";
            }
            if (
              hasValue(fields.ViaDataItems.ADDRESS.CITY) &&
              fields.ViaDataItems.ADDRESS.CITY.length > 0
            ) {
              address += fields.ViaDataItems.ADDRESS.CITY + ", ";
            }
            if (
              hasValue(fields.ViaDataItems.ADDRESS.STATECODE) &&
              fields.ViaDataItems.ADDRESS.STATECODE.length > 0
            ) {
              address += fields.ViaDataItems.ADDRESS.STATECODE + " ";
            }
            if (
              hasValue(fields.ViaDataItems.ADDRESS.POSTALCODE) &&
              fields.ViaDataItems.ADDRESS.POSTALCODE.length > 0
            ) {
              address += fields.ViaDataItems.ADDRESS.POSTALCODE;
            }
            listRows.push({
              id: i,
              NAMETYPE: fields.NAMETYPE,
              LASTNAME: fields.LASTNAME,
              FIRSTNAME: fields.FIRSTNAME,
              MIDDLENAME: fields.MIDDLENAME,
              SUFFIX: fields.SUFFIX,
              DOB: getMMDDYYYY(fields.DOB),
              ADDRESS: address.trim(),
            });
          }
        } else if (hasValue(array.NAMEID)) {
          const fields = array;
          let address = "";
          if (
            hasValue(fields.ViaDataItems.ADDRESS.STREETNUMBER) &&
            fields.ViaDataItems.ADDRESS.STREETNUMBER.length > 0
          ) {
            address += fields.ViaDataItems.ADDRESS.STREETNUMBER + " ";
          }
          if (
            hasValue(fields.ViaDataItems.ADDRESS.STREETNAME) &&
            fields.ViaDataItems.ADDRESS.STREETNAME.length > 0
          ) {
            address += fields.ViaDataItems.ADDRESS.STREETNAME + " ";
          }
          if (
            hasValue(fields.ViaDataItems.ADDRESS.APARTMENT) &&
            fields.ViaDataItems.ADDRESS.APARTMENT.length > 0
          ) {
            address += fields.ViaDataItems.ADDRESS.APARTMENT + " ";
          }
          if (
            hasValue(fields.ViaDataItems.ADDRESS.CITY) &&
            fields.ViaDataItems.ADDRESS.CITY.length > 0
          ) {
            address += fields.ViaDataItems.ADDRESS.CITY + ", ";
          }
          if (
            hasValue(fields.ViaDataItems.ADDRESS.STATECODE) &&
            fields.ViaDataItems.ADDRESS.STATECODE.length > 0
          ) {
            address += fields.ViaDataItems.ADDRESS.STATECODE + " ";
          }
          if (
            hasValue(fields.ViaDataItems.ADDRESS.POSTALCODE) &&
            fields.ViaDataItems.ADDRESS.POSTALCODE.length > 0
          ) {
            address += fields.ViaDataItems.ADDRESS.POSTALCODE;
          }
          listRows.push({
            id: 1,
            NAMETYPE: fields.NAMETYPE,
            LASTNAME: fields.LASTNAME,
            FIRSTNAME: fields.FIRSTNAME,
            MIDDLENAME: fields.MIDDLENAME,
            SUFFIX: fields.SUFFIX,
            DOB: getMMDDYYYY(fields.DOB),
            ADDRESS: address.trim(),
          });
        }
      }
    }

    const listColumns = [
      {
        field: "NAMETYPE",
        renderHeader: (params) => <strong>{"Type"}</strong>,
        width: 30,
      },
      {
        field: "LASTNAME",
        renderHeader: (params) => <strong>{"Last Name"}</strong>,
        width: 150,
      },
      {
        field: "FIRSTNAME",
        renderHeader: (params) => <strong>{"First Name"}</strong>,
        width: 130,
      },
      {
        field: "MIDDLENAME",
        renderHeader: (params) => <strong>{"Middle Name"}</strong>,
        width: 130,
      },
      {
        field: "SUFFIX",
        renderHeader: (params) => <strong>{"Suffix"}</strong>,
        width: 50,
      },
      {
        field: "DOB",
        renderHeader: (params) => <strong>{"DOB"}</strong>,
        width: 100,
      },
      {
        field: "ADDRESS",
        renderHeader: (params) => <strong>{"Address"}</strong>,
        width: 250,
      },
    ];

    const optionSelect = (
      <Fragment>
        <Grid item xs={12}>
          <div style={{ height: headerHeight + rowHeight * 4 }}>
            <DataGrid
              rows={listRows}
              columns={listColumns}
              onRowClick={this.handleRowClick}
              getRowHeight={() => "auto"}
            />
          </div>
        </Grid>
      </Fragment>
    );

    searchResults = <Fragment>{optionSelect}</Fragment>;

    let searchOptionSection = null;
    let searchSection = null;
    let permitted = false;
    const appOptions = getAppOptions();
    if (doLog()) console.log("Person appOptions:", appOptions);
    const permissionOption = appOptions["fbr"];
    if (
      hasValue(permissionOption) &&
      permissionOption.toUpperCase().startsWith("T")
    ) {
      permitted = true;
    }
    if (doLog()) console.log("Person permitted:", permitted);
    if (permitted) {
      searchOptionSection = (
        <Grid item xs={12}>
          {this.getFormField("timsSearch", false, true)}
        </Grid>
      );

      if (this.state.timsSearch.value === "Y") {
        searchSection = (
          <Fragment>
            {/* <Grid item xs={12}>
            <p>Search in TIMS: (Optional)</p>
          </Grid> */}
            <Grid item xs={3}>
              {this.getFormField("lastNameSearch", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("firstNameSearch", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("middleNameSearch", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("suffixSearch", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("raceSearch", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("sexSearch", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("dobSearch", false, true)}
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                onClick={this.handleSearchTIMS.bind(this)}
              >
                Search
              </Button>
            </Grid>
            {searchResults}
            <Grid item xs={12}>
              <hr />
            </Grid>
          </Fragment>
        );
      }
    }

    let businessSection = null;
    // if (this.state.useBusinessFields === true) {
    if (this.state.nameType.value === "O") {
      businessSection = (
        <Fragment>
          <Grid item xs={12}>
            {this.getFormField("workBusinessName", true, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("workPhone", false, true)}
          </Grid>
          <Grid item xs={8} />
        </Fragment>
      );
    }

    let personSection = null;
    // if (this.state.useBusinessFields !== true) {
    if (this.state.nameType.value !== "O") {
      personSection = (
        <Fragment>
          <Grid item xs={3}>
            {this.getFormField("firstName", false, true)}
          </Grid>
          <Grid item xs={3}>
            {this.getFormField("middleName", false, true)}
          </Grid>
          <Grid item xs={6}>
            {this.getFormField("lastName", false, true)}
          </Grid>
          {/* <Grid item xs={6}>
            {this.getFormField("email", false, true)}
          </Grid>
          <Grid item xs={6} /> */}
          <Grid item xs={4}>
            {this.getFormField("race", false, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("ethnicity", false, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("sex", false, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("dob", false, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("eyeColor", false, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("hairColor", false, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("height", false, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("weight", false, true)}
          </Grid>
          <Grid item xs={4} />
          <Grid item xs={4}>
            {this.getFormField("homePhone", false, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("cellPhone", false, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("workPhone", false, true)}
          </Grid>
          <Grid item xs={3}>
            {this.getFormField("oln", false, true)}
          </Grid>
          <Grid item xs={3}>
            {this.getFormField("olnState", false, true)}
          </Grid>
          <Grid item xs={3}>
            {this.getFormField("ssn", false, true)}
          </Grid>
          <Grid item xs={3} />
          <Grid item xs={12}>
            <hr />
          </Grid>
          <Grid item xs={12}>
            <p className={classes.SeparateLabel}>Home Address</p>
          </Grid>
          <Grid item xs={2}>
            {this.getFormField("homeStreetNumber", false, true)}
          </Grid>
          <Grid item xs={6}>
            {this.getFormField("homeStreetName", false, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("homeApt", false, true)}
          </Grid>
          <Grid item xs={6}>
            {this.getFormField("homeCity", false, true)}
          </Grid>
          <Grid item xs={3}>
            {this.getFormField("homeState", false, true)}
          </Grid>
          <Grid item xs={3}>
            {this.getFormField("homeZip", false, true)}
          </Grid>
          <Grid item xs={12}>
            <p className={classes.SeparateLabel}>Work Information</p>
          </Grid>
          <Grid item xs={12}>
            {this.getFormField("workBusinessName", true, true)}
          </Grid>
        </Fragment>
      );
    }

    let mainSection = null;
    if (this.state.deleted.value !== "Y") {
      mainSection = (
        <Card>
          <Grid container item className={classes.Card}>
            <SectionHeading sectionTitle="Person/Business Details" />
            {informationSection}
            <Grid item xs={12}>
              <hr />
            </Grid>
            {searchOptionSection}
            {searchSection}
            <Grid item xs={4}>
              {this.getFormField("personInvolvement", false, true)}
            </Grid>
            <Grid item xs={8}>
              {this.getFormField("nameType", false, true)}
            </Grid>
            {personSection}
            {businessSection}
            <Grid item xs={2}>
              {this.getFormField("workStreetNumber", false, true)}
            </Grid>
            <Grid item xs={6}>
              {this.getFormField("workStreetName", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("workApt", false, true)}
            </Grid>
            <Grid item xs={6}>
              {this.getFormField("workCity", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("workState", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("workZip", false, true)}
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                onClick={this.handleAddButton.bind(this)}
              >
                Add another
              </Button>
              &nbsp;&nbsp;
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                onClick={this.handleDeleteButton.bind(this)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={6}></Grid>
          </Grid>
        </Card>
      );
    }

    return mainSection;
  }
}

const mapStateToProps = (state) => {
  // if (doLog()) console.log('Person.mapStateToProps token:', state.auth.token);
  return {
    loading: state.auth.loading,
    result: state.trans.result,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    //
    configuration: state.trans.configuration,
    //
    sharedIncidentDetails: state.trans.sharedIncidentDetails,
    personInvolvementList: state.trans.personInvolvementList,
    //
    raceList: state.trans.raceList,
    sexList: state.trans.sexList,
    ethnicityList: state.trans.ethnicityList,
    eyeColorList: state.trans.eyeColorList,
    hairColorList: state.trans.hairColorList,
    stateList: state.trans.stateList,
    //
    personArray: state.trans.personArray,
    personSelectFieldList: state.trans.personSelectFieldList,
    personTextFieldList: state.trans.personTextFieldList,
    //
    selectedIncidentTypeData: state.trans.selectedIncidentTypeData,
    customTextList: state.trans.customTextList,
    requiredFieldList: state.trans.requiredFieldList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchValidCodeLists: (ori, token, listName, codeGroup) =>
      dispatch(actions.fetchValidCodeLists(ori, token, listName, codeGroup)),
    onAddToPersonArray: (personArray, personItem) =>
      dispatch(actions.addToPersonArray(personArray, personItem)),
    onDeleteFromPersonArray: (personArray, personItem) =>
      dispatch(actions.deleteFromPersonArray(personArray, personItem)),
    onSetPersonArray: (personArray) =>
      dispatch(actions.setPersonArray(personArray)),
    onSetPersonSelectFieldList: (fieldList) =>
      dispatch(actions.setPersonSelectFieldList(fieldList)),
    onSetPersonTextFieldList: (fieldList) =>
      dispatch(actions.setPersonTextFieldList(fieldList)),
    onRunTransaction: (options, token, transDesc) =>
      dispatch(actions.runTransaction(options, token, transDesc)),
    onClearTransactionResult: () => dispatch(actions.clearTransactionResult()),
    onClearTransDesc: () => dispatch(actions.clearTransDesc()),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(Person)
// );
export default connect(mapStateToProps, mapDispatchToProps)(Person);
